"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Level_1 = require("../../Level");
const namespaces_1 = require("../../namespaces");
/**
 * Tries to correct missing entry point in hydra:ApiDocumentation resource.
 */
class EntryPointCorrectingGraphTransformer {
    /** @inheritDoc */
    transform(graph, processor, options) {
        const apiDocumentation = !!graph
            ? graph.find(_ => !!_["@type"] && _["@type"].indexOf(namespaces_1.hydra.ApiDocumentation) !== -1)
            : null;
        if (!!apiDocumentation &&
            !apiDocumentation[namespaces_1.hydra.entrypoint] &&
            !!options &&
            processor.supports(options.auxiliaryResponse) !== Level_1.Level.None &&
            options.auxiliaryOriginalUrl.match(/.+:\/\/[^\/]+\/?/)) {
            apiDocumentation[namespaces_1.hydra.entrypoint] = [{ "@id": options.auxiliaryOriginalUrl }];
        }
        return graph;
    }
}
exports.default = EntryPointCorrectingGraphTransformer;
//# sourceMappingURL=EntryPointCorrectingGraphTransformer.js.map